import React from "react";
import { Col } from "react-bootstrap";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";

const Gift = () => {
    const { addBreadcrumb } = useBreadcrumbs();

    return (
        <AnimateWrapper>
            <BasicQuestion
                question={"Gaat het hier om een geschenk?"}
                answers={
                    <>
                        <Col xs={12} sm={6}>
                            <ChoiceCard
                                body={"Ja"}
                                onClick={() => {
                                    addBreadcrumb(
                                        {
                                            href: "/incoterm",
                                            text: "Incoterm"
                                        },
                                        { gift: true }
                                    );
                                }}
                            />
                        </Col>
                        <Col xs={12} sm={6}>
                            <ChoiceCard
                                body={"Nee"}
                                onClick={() => {
                                    addBreadcrumb(
                                        {
                                            href: "/incoterm",
                                            text: "Incoterm"
                                        },
                                        { gift: false }
                                    );
                                }}
                            />
                        </Col>
                    </>
                }
            />
        </AnimateWrapper>
    );
};

export default Gift;
